import React from "react"

const ProductTilesLoader = ({ rowCols = 3 }) => (
  <div
    className={`product-listing__row row-cols-${rowCols}`}
    aria-hidden="true"
  >
    {Array.from({ length: 6 }, (_, index) => (
      <div className="product-listing__tile" key={index}>
        <div className="product-tile">
          <div className="product-list-tile__image">
            <div className="shimmer-loading__image shimmer"></div>
          </div>
          <div className="product-tile__details">
            <div className="width-full">
              <p className="shimmer-loading__para shimmer width-170 mt60"></p>
              <p className="shimmer-loading__headpara shimmer mb20 width-full"></p>
              <p className="shimmer-loading__para shimmer width-100"></p>
            </div>
          </div>
        </div>
      </div>
    ))}
  </div>
)

export default ProductTilesLoader
